var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":require("../assets/imgs/logo.png")},on:{"click":function($event){return _vm.$router.push('/home')}}}),_c('Icon',{staticClass:"menu-btn",attrs:{"name":"menu"},nativeOn:{"click":function($event){return _vm.$emit('setMenuVisiableTrue')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }